import { render, staticRenderFns } from "./nested-input.vue?vue&type=template&id=fc12a6c2&scoped=true"
import script from "./nested-input.vue?vue&type=script&lang=js"
export * from "./nested-input.vue?vue&type=script&lang=js"
import style0 from "./nested-input.vue?vue&type=style&index=0&id=fc12a6c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc12a6c2",
  null
  
)

export default component.exports